import { apiClient } from '@/api/client';
import type { SpringPage } from '@/types/students';

/**
 * Minimal Course shape — just what the Kỉ Luật page needs to populate its
 * course dropdown. The backend returns much richer CourseDetailResponse;
 * we ignore the rest.
 */
export interface CourseOption {
  id: number;
  name: string | null;
}

/**
 * List courses of one community. Backed by the existing private endpoint
 * `GET /private/communities/{communityId}/courses` (no admin-specific
 * endpoint exists yet; admins can read it with the bearer token).
 */
export async function listCommunityCourses(
  communityId: number,
): Promise<CourseOption[]> {
  const { data } = await apiClient.get<SpringPage<CourseOption>>(
    `/private/communities/${communityId}/courses`,
    { params: { page: 0, size: 100, sort: 'createdAt', direction: 'desc' } },
  );
  return data.content;
}
